import { useSearchParams } from "react-router-dom";
import { Button } from "../components/ui/button";
import { CheckCircle } from "lucide-react";

const ThankYouPage = () => {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('order_id');

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
              <CheckCircle className="h-6 w-6 text-green-600" />
            </div>
            <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
              Thank You!
            </h2>
            <p className="mt-2 text-center text-sm text-gray-600">
              Your payment was successful
            </p>
            {orderId && (
              <div className="mt-4 p-4 bg-gray-50 rounded-md">
                <p className="text-sm text-gray-700">
                  Order ID: <span className="font-mono font-semibold">{orderId}</span>
                </p>
              </div>
            )}
            <div className="mt-6">
              <p className="text-center text-sm text-gray-500">
                We've sent a confirmation email with your order details.
                Your order is now being processed.
              </p>
            </div>
            <div className="mt-6">
              <Button
                onClick={() => window.location.href = '/'}
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700"
              >
                Continue Shopping
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Checkout Cancelled Page Component

export { ThankYouPage };
export default ThankYouPage;
